import { ActionCreator } from 'redux';
import { ParsedAddress } from "../../dtos/ParsedAddress";
import {
    ADDRESS_INPUT_FOCUS,
    CHANGE_ADDRESS_SEARCH_VALUE,
    LOAD_LIST_OF_OPTIONS,
    ON_CLOSE_BUTTON,
    ON_ITEM_LIST_CLICK,
    TOGGLE_SEARCH_STATUS_VALUE
} from "./LocalConstants";
import {
    ChangeSearchStatusAction,
    ChangeSearchValueAction,
    OnAddressInputFocusAction,
    OnCloseButtonAction,
    OnItemListClickAction,
    OnLoadItemListFromRequestAction
} from "./LocalTypes";

export const changeSearchValue: ActionCreator<ChangeSearchValueAction> = (value: string) => ({
    type: CHANGE_ADDRESS_SEARCH_VALUE,
    payload: {
        value
    }
})

export const changeSearchStatusValue: ActionCreator<ChangeSearchStatusAction> = (isSearching: boolean) => ({
    type: TOGGLE_SEARCH_STATUS_VALUE,
    payload: {
        isSearching
    }
})

export const onAddressInputFocus: ActionCreator<OnAddressInputFocusAction> = () => ({
    type: ADDRESS_INPUT_FOCUS
})

export const onLoadItemListFromRequest: ActionCreator<OnLoadItemListFromRequestAction> = (items: string[], itemObject: ParsedAddress[]) => ({
    type: LOAD_LIST_OF_OPTIONS,
    payload: {
        items,
        itemObject
    }
})

export const onItemListClick: ActionCreator<OnItemListClickAction> = (focused: boolean, selected: boolean, value?: string, ) => ({
    type: ON_ITEM_LIST_CLICK,
    payload: {
        focused,
        selected,
        value
    }
})

export const onCloseButton: ActionCreator<OnCloseButtonAction> = () => ({
    type: ON_CLOSE_BUTTON
})




// WEBPACK FOOTER //
// ./src/components/AddressAutoComplete/LocalActions.ts